// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"cdb1d87f","451":"0e78b8a7","453":"b44c4198"}[chunkId] + ".chunk.js";
};